import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getOpenBoardListStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    listContent: {
      paddingHorizontal: 16,
      paddingBottom: 24,
    },
    separator: {
      height: 10,
    },
    centered: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      paddingVertical: 48,
      gap: 10,
    },
    emptyTitle: {
      fontSize: 16,
      fontWeight: '800',
      color: theme.black,
      textAlign: 'center',
    },
    emptyBody: {
      fontSize: 13,
      fontWeight: '500',
      color: theme.gray[500],
      textAlign: 'center',
    },
    errorTitle: {
      fontSize: 15,
      fontWeight: '800',
      color: theme.error,
      textAlign: 'center',
    },
    clearButton: {
      minHeight: 44,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 20,
      borderRadius: 10,
      backgroundColor: theme.primary,
      marginTop: 4,
    },
    clearButtonPressed: {
      opacity: 0.85,
    },
    clearButtonText: {
      fontSize: 14,
      fontWeight: '800',
      color: theme.onPrimary,
    },
  });
